import { render } from "./DashboardKpi.vue?vue&type=template&id=06eb7540&scoped=true"
import script from "./DashboardKpi.vue?vue&type=script&lang=js"
export * from "./DashboardKpi.vue?vue&type=script&lang=js"

import "./DashboardKpi.vue?vue&type=style&index=0&id=06eb7540&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06eb7540"]])

export default __exports__